import Dialog from 'components/Dialog';
import React, { useState } from 'react';

import { StepInformation } from './CreateStyled';
import FileUploader from 'components/FileUploader';

export const useUploadDialog = (onUpload) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleUpload = (file) => {
    onUpload(file);
    setOpen(false);
  };

  const renderDialog = () => (
    <Dialog
      open={open}
      hideActions
      showFloatingCancel
      onClose={handleClose}
      title="Upload Title Search"
    >
      <StepInformation>Select and upload the title document below.</StepInformation>
      <FileUploader description="Title Search" addDocument={handleUpload} />
    </Dialog>
  );

  return [renderDialog, setOpen];
};

export default useUploadDialog;
